import axiosIns from '@/plugins/axios'
import {
  ApiList, ApiDetail,
} from '@/api/v2/types/json-api'
import { AggregationResultAttributes } from '@/api/v2/types/aggregation-result'

export type AggregationSingleResponse = ApiDetail<AggregationResultAttributes, 'aggregation'>

export interface UserAttrs {
  id: number
  name: string
  role: string
}
export type UserListResponse = ApiList<UserAttrs, 'user'>

export async function fetchAggregation(
  aggregationContainerId: number,
  aggregationId: number,
  params: {
    start_date?: string
    end_date?: string
    context_type?: 'User' | 'Club' | 'TableDetail'
    context_id?: number | null
  },
): Promise<AggregationResultAttributes> {
  const res = await axiosIns.get<AggregationSingleResponse>(
    `/v2/report/aggregation_containers/${aggregationContainerId}/aggregations/${aggregationId}`,
    { params },
  )

  return res.data.data.data.attributes
}

export async function enqueueAggregationJob(
  aggregationContainerId: number,
  aggregationId: number,
  params: {
    start_date?: string
    end_date?: string
  },
): Promise<void> {
  await axiosIns.get(
    `/v2/report/aggregation_containers/${aggregationContainerId}/aggregations/${aggregationId}/enqueue`,
    { params },
  )
}

export async function getAggregationJobStatus(
  aggregationContainerId: number,
  aggregationId: number,
  params: {
    start_date?: string
    end_date?: string
  },
): Promise<{
  status: string
  result?: AggregationResultAttributes
  errorMessage?: string
  meta: {
    createdAt: string
    updatedAt: string
  }
}> {
  const res = await axiosIns.get<{
    status: string
    data: {
      status: string
      result: AggregationSingleResponse['data'] | null,
      errorMessage?: string
      meta: {
        createdAt: string
        updatedAt: string
      }
    }
  }>(
    `/v2/report/aggregation_containers/${aggregationContainerId}/aggregations/${aggregationId}/status`,
    { params },
  )

  const {
    status, result, errorMessage, meta,
  } = res.data.data

  return {
    status,
    result: result?.data?.attributes,
    errorMessage,
    meta,
  }
}

export async function fetchAvailableUsers(aggregationContainerId: number, aggregationId: number): Promise<UserAttrs[]> {
  const res = await axiosIns.get<UserListResponse>(
    `/v2/report/aggregation_containers/${aggregationContainerId}/aggregations/${aggregationId}/available_users`,
  )

  return res.data.data.data.map(r => r.attributes)
}
